import React, { useState } from 'react';

import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import StreamTextDisplay from 'blockscope/components/aiSystem/panel/StreamTextDisplay';

/**
 * Renders a full wallet profile message
 * @param {Object} props - Component props
 * @param {Object|string} props.content - Message content
 */
const BaseResponseWithAnalysis = ({ content }) => {
  const [showInternalThought, setShowInternalThought] = useState(false);

  return (
    <div
      className='full-wallet-profile-message'
      style={{
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        maxWidth: '100%',
      }}
    >
      {/* Main message */}
      <div className='mb-3'>
        <StreamTextDisplay text={content.fullAnalysis} />
      </div>

      {/* Internal Thought section - compact style */}
      {content.internalThought && (
        <div className='internal-thought-section mb-2'>
          <small
            className={`d-inline-flex align-items-center px-2 py-1 rounded cursor-pointer ${
              showInternalThought ? 'bg-primary bg-opacity-10' : 'bg-light'
            }`}
            onClick={() => setShowInternalThought(!showInternalThought)}
            style={{ cursor: 'pointer', fontSize: '0.85rem' }}
          >
            <FontAwesomeIcon
              icon={faCircleInfo}
              className={`me-1 ${
                showInternalThought ? 'text-primary' : 'text-secondary'
              }`}
              style={{ fontSize: '0.8rem' }}
            />
            <span>Thought Process</span>
          </small>

          {showInternalThought && (
            <div className='content-body mt-1 ps-2 border-start border-2 border-light'>
              <small
                className='d-block py-1 text-secondary'
                style={{ fontSize: '0.85rem' }}
              >
                {content.internalThought}
              </small>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BaseResponseWithAnalysis;

